import { render, staticRenderFns } from "./SupsisLogo.vue?vue&type=template&id=f7bc016c"
import script from "./SupsisLogo.vue?vue&type=script&lang=js"
export * from "./SupsisLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports